import React from 'react';
import VIDEO_PATH from '../../Assets/video.mp4';

function video() {

  return (
    <div>
        <div className="">
            <div className="">
                <div>
                <video src={VIDEO_PATH} width="100%" height="200px" loop playsInline controls data-uk-video="autoplay: inview" controlsList="nodownload"></video>
                </div>
            </div>
        </div>
    </div>
  )
}

export default video